module.exports = __webpack_public_path__ + "img/profitability10.37524e8e.png";